var vskoFile = angular.module('vskoFile', []);

vskoFile.directive('vskoFile', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-file.html'),
    required: ['ngModel'],
    scope: {
      ngModel: '='
    },
    controller: ['$scope', function($scope) {
      $scope.openDialog = function() {
        
      }
    }]
  };
}]);

vskoFile.directive('vskoFileModel', ['$parse', function($parse) {
  return {
    restrict: 'A',
    scope: {

    }
  }
}]);
